import configureStore from 'utils/redux/configureStore';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from './reducers';
import rootSaga from './sagas';

export default history => {
  const store = configureStore(rootReducer, rootSaga, [
    routerMiddleware(history),
  ]);

  // Make reducers hot reloadable, see http://mxs.is/googmo
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/modules/catalog/store.js